import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation PipOptionDelete($uid: String!){
        pip_option_delete (uid: $uid) {
            success
        }
    }
`;

export async function pipOptionDelete(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ pip_option_delete: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.pip_option_delete;
}
